import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import Grid2 from "@mui/material/Grid2";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { getCraftLetter } from "@/utils/craftLetter";

type Props = {};

export const CraftsFilter = ({}: Props) => {
	const {
		state: { crafts },
	} = useAssetDetailsContext();
	const [searchParams, setSearchParams] = useSearchParams();

	const craft = searchParams.get("craft") ?? "";

	const handleFilter = (e: any) => {
		searchParams.set("craft", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box
			sx={{
				"& .MuiSelect-select": {
					backgroundColor: "#FFF",
					paddingTop: "6px",
					paddingBottom: "6px",
				},
			}}
		>
			<FormControl variant="outlined" size="small" sx={{ width: "100%" }}>
				<InputLabel id="crafts-select-label">Crafts</InputLabel>
				<Select
					labelId="crafts-select-label"
					id="crafts-select"
					value={craft}
					onChange={handleFilter}
					label="Crafts"
				>
					{crafts.map((craft) => {
						return (
							<MenuItem key={`logId-${craft.id}`} value={craft.id}>
								<Grid2 container alignItems="center">
									<Box
										sx={{
											height: 20,
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											paddingLeft: "10px",
										}}
									>
										<Box
											sx={{
												height: 24,
												width: 24,
												borderRadius: "4px",
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												background: craft.color || "#FFFFFF",
											}}
										>
											<Box
												sx={{
													color: "#FFF",
													fontWeight: 600,
													margin: "auto 0",
												}}
											>
												{getCraftLetter(craft.description, craft.code)}
											</Box>
										</Box>
									</Box>
									<Box sx={{ marginLeft: "10px" }}>{craft.description}</Box>
								</Grid2>
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</Box>
	);
};
